<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <h2 style="float: left; margin-left: 15px">Fault Report</h2>
      <br />
      <el-button style="float: right; margin-right: 30px" @click="Create()"
        >Create</el-button
      >
    </el-row>
    <br />
    <el-card>
      <el-row>
        <el-form
          :inline="true"
          :model="query"
          :label-position="'top'"
          class="demo-form-inline"
        >
          <el-col>
            <el-form-item label="Partner" prop="partner">
              <el-select
                @change="loadCustomers"
                v-model="query.partner"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in partnerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Customer" prop="customer">
              <el-select
                @change="load"
                v-model="query.customer"
                placeholder="Select"
                filterable
                clearable
              >
                <el-option
                  v-for="item in customerSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>

        <el-col>
          <el-button
            type="primary"
            @click="
              query.page = 1;
              load();
            "
            >Filter</el-button
          >
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
        <el-col>  
          <el-table
            v-loading="loading"
            :data="searchResult.faultReports"
            class="border"
          >
            <el-table-column type="index" width="50" />
            <el-table-column prop="createdAt" label="createdAt" />
            <el-table-column prop="customer" label="Customer" />
            <el-table-column prop="pointPath" label="Point"> </el-table-column>
            <el-table-column prop="faultType" label="Fault Type" />
            <el-table-column prop="severity" label="Severity" />
            <el-table-column label="Actions">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="Delete(scope)"
                  >Delete</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24" style="text-align: right">
          <el-pagination
            layout="prev, pager, next,sizes"
            :total="searchResult.total"
            :page-sizes="pageSizes"
            :page-size.sync="query.pageSize"
            :current-page.sync="query.page"
            @current-change="load"
            @size-change="load"
          ></el-pagination>
          <!-- Table -->
        </el-col>
      </el-row>
    </el-card>

    <el-dialog width="30%" title="Create Fault Report" :visible.sync="showForm">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        v-loading="formLoading"
        label-width="130px"
      >
        <el-form-item label="Partner" prop="partner">
          <el-select
            v-model="form.partner"
            placeholder="Select"
            clearable
            filterable
            @change="loadCustomersForCreateFaultReport"
          >
            <el-option
              v-for="item in partnerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Customer" prop="customer">
          <el-select v-model="form.customer" placeholder="Select" filterable clearable>
            <el-option
              v-for="item in customerSelect"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Point Id" prop="pointId">
          <el-input
            placeholder="Please input"
            v-model="form.pointId"
          ></el-input>
        </el-form-item>
        <el-form-item label="Fault type" prop="faultType">
          <el-select v-model="form.faultType" placeholder="Select" clearable>
            <el-option
              v-for="item in faultTypeNames"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Severity" prop="severity">
          <el-select v-model="form.severity" placeholder="Select" clearable>
            <el-option
              v-for="item in severityTypes"
              :key="item.value"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="CreateFaultReport()"
            >Create</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      width="80%"
      heas
      title="Print Report"
      :visible.sync="previewShowForm"
    >
      <el-row>
        <el-col :span="24">
          <faultReportPdf id="printArea" :form="prePrintValue"></faultReportPdf>
        </el-col>
      </el-row>
      <el-row style="margin-top: 40px">
        <el-col :span="4">
          <el-button type="primary" @click="printNow()"> Print</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="previewShowForm = !previewShowForm"
            >Cancel</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
// import axios from "axios";
import faultReportPdf from "./faultReportPdf.vue";
import dayjs from "dayjs";
export default {
  name: "FaultReport",
  components: {
    faultReportPdf,
  },
  data() {
    return {
      previewShowForm: false,
      prePrintValue: "",
      query: {
        point: "",
        partner: "",
        customer: "",
        page: 1,
        pageSize: 10,
      },
      severityTypes: [
        { label: "Attention", value: "attention", key: "attention" },
        { label: "Hazard", value: "hazard", key: "hazard" },
        { label: "Critical", value: "critical", key: "critical" },
      ],
      pageSizes: [10, 25, 50, 75],
      editId: "",
      showForm: false,
      formLoading: false,
      certs: {},
      showCertsForm: false,
      form: {
        partner: "",
        customer: "",
        pointId: "",
        faultType: "",
        severity: "",
      },
      rules: {
        customer: [
          {
            required: true,
            message: "Please select customer",
            trigger: "blur",
          },
        ],
        point: [
          { required: true, message: "Please input point", trigger: "blur" },
        ],
        faultType: [
          {
            required: true,
            message: "Please select faultType",
            trigger: "blur",
          },
        ],
        severity: [
          {
            required: true,
            message: "Please input severity",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getFaultReports(this.query);
    this.getFaultTypes();
    this.getPartners();
    this.getCustomers();
  },
  computed: {
    ...mapState("faultReport", ["searchResult", "loading"]),
    ...mapState("faultTypes", ["searchResultFaultTypes", "total"]),
    ...mapState("partner", ["customers", "partners"]),

    customerSelect() {
      return this.customers.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },

    partnerSelect() {
      return this.partners.map((x) => {
        return {
          value: x._id,
          label: `${x.name}(${x._id})`,
          key: x._id,
        };
      });
    },
    faultTypeNames() {
      return this.searchResultFaultTypes.faultTypes.map((x) => {
        return x._id;
      });
    },
  },
  methods: {
    loadCustomersForCreateFaultReport() {
      return this.getCustomers({ partner: this.form.partner });
    },
    async loadCustomers() {
      this.query.customer = "";
      this.form.customer = "";
      await this.loadCustomersOnly();
      await this.load();
    },
    ...mapActions("faultReport", [
      "getFaultReports",
      "createFaultReport",
      "deleteFaultReport",
    ]),
    ...mapActions("partner", ["getPartners", "getCustomers"]),
    ...mapActions("faultTypes", ["getFaultTypes"]),
    download(row) {
      this.prePrintValue = row;
      this.previewShowForm = true;
      // let urlString = `${process.env.VUE_APP_APIURL}/fault-reports/${reportId}/download-link`;
      // axios.get(urlString).then((res) => {
      //   this.downloadUrl(res.data.url);
      // });
    },
    printNow() {
      // Get HTML to print from element
      const prtHtml = document.getElementById("printArea").innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);
      WinPrint.document.title = `${
        this.prePrintValue.customer
      }_${dayjs().format("DD-MM-YYYY HH:mm:ss")}`;
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
      }, 200);
    },
    downloadUrl(href) {
      window.open(href, "Download");
    },
    load() {
      this.getFaultReports(this.query);
    },
    adviseSystemAdmin() {
      this.$message.info("advise to the system admin");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    CreateFaultReport() {
      this.$confirm("Are you sure?", "Warning", {
        confirmButtonText: "Yes, send",
        cancelButtonText: "No",
        type: "warning",
      }).then(() => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.formLoading = true;
            this.createFaultReport({
              ...this.form,
            })
              .finally(() => {
                this.showForm = false;
                this.formLoading = false;
                this.load();
              })
              .catch((e) => {
                this.$message.error(e.toString());
              });
          }
        });
      });
    },
    Delete(scope) {
      this.$confirm(
        "This will permanently delete the Fault Report. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => this.deleteFaultReport(scope.row._id))
        .then(() => this.getFaultReports(this.query))
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    copyIdToClipboard(id) {
      this.$clipboard(id);
      this.$message.info("'" + id + "' " + "copy to clipboard success");
    },
    Create() {
      this.editId = undefined;
      this.showForm = true;
    },
    Cancel() {
      this.editId = "";
      this.form = {
        customer: "",
      };
    },
    Edit(scope) {
      this.form = {
        customer: scope.row.customer,
      };
      this.editId = scope.row._id;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
abbr {
  max-width: 150px;
  word-break: initial;
}
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
</style>